import { DealerConfig } from './DealerConfig';

export interface DealerBillingInfo {
  id: number;
  bac: number;
  user_id?: number | null;
  dealer_config: DealerConfig | null;
  is_valid: boolean;
  created_at: Date;
  updated_at: Date;
  sent_at?: Date | null;
  vmt_error?: string | null;
  vmt_status?: string | null;

  payload: DealerBillingPayload;
}

export function DealerBillingInfoMapper(item: DealerBillingInfo): DealerBillingInfo {
  return {
    ...item,
    sent_at: item.sent_at ? new Date(item.sent_at) : null,
    created_at: item.created_at ? new Date(item.created_at) : null,
    updated_at: item.updated_at ? new Date(item.updated_at) : null,
  };
}

export interface DealerBillingPayload {
  GMVMTRequest?: GMVMTStoreRequestItem | null;
  enrollment_report?: GMEnrollmentAPIReportItem | null;
  dealer_locator_response_vendor?: any | null;
}

export interface GMVMTStoreRequestItem {
  billingDate?: string | null;
  serviceMonth?: string | null;
  selectionDate?: string | null;
  effectiveDate?: string | null;
  countryCd?: string | null;
  categoryCd?: string | null;
  vendorCd?: string | null;
  bac?: string | null;
  vendorInvoiceNumber?: string | null;
  gmBrandCd?: string[] | null;
  productCd?: string | null;
  productDescription?: string | null;
  designation?: string | null;
  occurrence?: string | null;
  itemQuantity?: string | null;
  dealerPrice?: string | null;
  promoCd?: string | null;
  filler?: string | null;
  imrUsage?: string | null;
  imrPercentage?: string | null;
  status?: string | null;
  lastUpdatedDate?: string | null;
  lastUpdatedBy?: string | null;
}

export interface GMEnrollmentAPIReportItem {
  bac: number; // Business account code
  dealerCd: string; // Dealer code
  dealerName: string; // Name of the dealer
  brandName?: string[] | null; // Brand names associated with the dealer
  signerName?: string | null; // Name of the signer
  signerPhone?: string | null; // Phone number of the signer
  signerEmail?: string | null; // Email address of the signer
  programContact1Name?: string | null; // Name of the primary program contact
  programContact1UserID?: string | null; // User ID of the primary program contact
  programContact1Phone?: string | null; // Phone number of the primary program contact
  programContact1Email?: string | null; // Email of the primary program contact
  programContact2Name?: string | null; // Name of the secondary program contact
  programContact2UserID?: string | null; // User ID of the secondary program contact
  programContact2Phone?: string | null; // Phone number of the secondary program contact
  programContact2Email?: string | null; // Email of the secondary program contact
  isTerminated: 'Y' | 'N'; // Termination status
  isTerminatedDate?: string | null; // Date of termination update
  enrolledDt?: string | null; // Enrollment initiation date
  enrollmentStatusCd: string | 'ENROLLED' | 'IN_PROGRESS' | 'OPTED_OUT'; // Status of the enrollment
  optOutDt?: string | null; // Opt-out date
  lastUpdateDt?: string | null; // Last update date
  enrolledPrereqs: string[]; // Prerequisite codes for enrollment
  programLevelCode?: string | null; // Enrollment level or tier
  programLevel?: string | null; // Enrollment level or tier
  customFields: Record<string, any>; // Additional info
  productSelections?: any | null; // Product selections
  vendors?: any | null; // Vendor information
}
